<template>
  <div >
    <!-- <h1>TheWarehouse</h1> -->
     <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "TheWarehouse",
 
 
};
</script>